import './js/sites/dotcom.js'